import React, { Component } from "react";
import {
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  message,
  Space,
  Switch,
  Tag,
  Typography,
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  ButtonItem,
  InputItem,
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { DollarOutlined, CarOutlined, EnvironmentOutlined, PhoneFilled, InfoCircleOutlined, UserOutlined } from "@ant-design/icons";
import PagosRemision from "../PagosRemision/PagosRemision";
import InsumoDetalleRow from "../../../../Components/InsumoDetalleRow";
import ModalMandarCorreoFacturas from "../../FacturasCajaChica/ModalMandarCorreoFacturas/ModalMandarCorreoFacturas";
import InfoCard from "../../../../Components/InfoCard";

const { Option } = Select;

moment.locale("es");

class VerRemision extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    todasInsumos: [],
    todasMonedas: null,
    objetoMonedas: null,
    impuestos: [],
    total: 0,
    totalPagar: 0,
    totalPagado: 0,
    subtotal: 0,
    ajusteSubtotal: 0,
    arrayImpuestos: [],
    arrayRetenciones: [],
    modalPagos: false,
    estado: 0,
    id: this.props.location.state.id,
    mostrarDetalles: true,
    modalCorreo: false,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "remisiones/datosRemision",
        { empresaId: this.props.empresaId, remisionId: this.state.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          let newState = {
            estado: res.data.remision.estado,
            total: res.data.remision.total,
            totalPagar: res.data.remision.totalPagar,
            totalPagado: res.data.remision.totalPagado,
            subtotal: res.data.remision.subtotal,
            arrayImpuestos: res.data.remision.arrayImpuestos,
            arrayRetenciones: res.data.remision.arrayRetenciones,
            ajusteSubtotal: res.data.remision.ajusteSubtotal,
            todasProveedores: res.data.proveedores,
            objetoProveedores: res.data.proveedores.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
            todasProyectos: res.data.proyectos,
            objetoProyectos: res.data.proyectos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
            todasInsumos: res.data.insumos,
            objetoInsumos: res.data.insumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre || value.descripcion}
                </Option>
              );
            }),
            todasMonedas: res.data.monedas,
            objetoMonedas: res.data.monedas.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.abreviacion}
                </Option>
              );
            }),
          };
          this.setState(newState, () => {
            this.formRef.current.setFieldsValue({
              ...res.data.remision,
              fechaRemision: moment(res.data.remision.fechaRemision),
              fechaPago: moment(res.data.remision.fechaPago),
              fechaVencimiento: moment(res.data.remision.fechaVencimiento),
              insumos: res.data.remision.insumos.map((insumo) => {
                const precioUnitarioConImpuestos =
                  insumo.precioUnitario + insumo.impuestos / insumo.cantidad;
                return { ...insumo, precioUnitarioConImpuestos };
              }),
            });
          });
        } else {
          message.error("Error no se encontro informacion de la venta");
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  cerrarPagosRemision() {
    this.consultarTodo();
    this.setState({
      modalPagos: false,
    });
  }

  abrirModalCorreo() {
    this.setState({ modalCorreo: true });
  }

  cerrarModalCorreo() {
    this.setState({ modalCorreo: false });
  }

  getInsumosColumns() {
    return [
      { title: "Clave", width: "5%" },
      { title: "Insumo", width: "20%" },
      { title: "Unidad", width: "5%" },
      { title: "Proyecto", width: "10%" },
      { title: "Subp.",  width: "8%"  },
      { title: "P.U.",   width: "10%" },
      { title: "P.U. c/Imp.", width: "10%" },
      { title: "Cant.",  width: "8%"  },
      { title: "Desc.",  width: "8%"  },
      { title: "Subtotal / Imp. / Total", width: "13%" },
    ];
  }

  renderInsumoRow({ key, name, fieldKey, restField, arrayKey }) {
    return (
      <React.Fragment key={key}>
        <tr>
          {/* Clave */}
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                const insumoSeleccionado = this.state.todasInsumos?.find(
                  (insumo) => insumo._id.toString() === insumoId?.toString()
                );
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                    {insumoSeleccionado?.clave || '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>

          {/* Insumo */}
          <td className="td-border">
            <FormItem {...restField} name={[name, "insumoId"]} fieldKey={[arrayKey, "insumoId"]} required noStyle>
              <SelectItem sinBorde autoFocus style={{ width: "100%" }} className="select-insumo-sin-word-break" placeholder="Insumo" disabled>
                {this.state.objetoInsumos}
              </SelectItem>
            </FormItem>
          </td>

          <td className="td-border">
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                  const insumoSeleccionado = this.state.todasInsumos?.find(
                    (insumo) => insumo._id.toString() === insumoId?.toString()
                  );
                  return (
                    <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                      {insumoSeleccionado?.unidad || '-'}
                    </div>
                  );
                }}
              </FormItem>
          </td>

          {/* Proyecto */}
          <td className="td-border">
            <FormItem {...restField} name={[name, "proyectoId"]} fieldKey={[arrayKey, "proyectoId"]} required noStyle>
              <SelectItem sinBorde disabled style={{ width: "100%" }} placeholder="Proyecto">
                {this.state.objetoProyectos}
              </SelectItem>
            </FormItem>
          </td>

          {/* Subproyecto */}
          <td className="td-border">
            <FormItem {...restField} noStyle shouldUpdate>
              {({ getFieldValue }) => {
                let arrayValue = getFieldValue("insumos");
                let subProyectos = null;
                if (arrayValue && arrayValue[arrayKey]?.proyectoId) {
                  const proyecto = this.state.todasProyectos?.find(
                    (v) => v._id === arrayValue[arrayKey].proyectoId
                  );
                  if (proyecto && Array.isArray(proyecto?.subProyectos)) {
                    subProyectos = proyecto.subProyectos.map((value) => (
                      <Option value={value._id} key={value._id}>
                        {value.nombre}
                      </Option>
                    ));
                  }
                }
                if (subProyectos && subProyectos.length > 0) {
                  return (
                    <FormItem {...restField} name={[name, "subProyectoId"]} fieldKey={[arrayKey, "subProyectoId"]} noStyle>
                      <SelectItem disabled sinBorde style={{ width: "100%" }} placeholder="Subproyecto">
                        {subProyectos}
                      </SelectItem>
                    </FormItem>
                  );
                }
                return null;
              }}
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem {...restField} name={[name, "precioUnitario"]} fieldKey={[arrayKey, "precioUnitario"]} noStyle required>
              <InputNumberItem sinBorde placeholder="Precio Unitario" disabled dinero />
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem name={[name, "precioUnitarioConImpuestos"]} noStyle required shouldUpdate>
              <InputNumberItem sinBorde disabled placeholder="Precio Unitario con Impuestos" dineroDisabled />
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem {...restField} name={[name, "cantidad"]} fieldKey={[arrayKey, "cantidad"]} required number noStyle>
              <InputNumberItem sinBorde placeholder="Cantidad" disabled />
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem {...restField} name={[name, "descuento"]} fieldKey={[arrayKey, "descuento"]} required number noStyle shouldUpdate initialValue={0}>
              <InputNumberItem sinBorde placeholder="Descuento" porcentaje max={100} disabled />
            </FormItem>
          </td>

          {/* Subtotal / Impuestos / Total*/}
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const subtotal  = getFieldValue(["insumos", arrayKey, "subtotal"])  || 0;
                const impuestos = getFieldValue(["insumos", arrayKey, "impuestos"]) || 0;
                const total     = getFieldValue(["insumos", arrayKey, "total"])     || 0;
                return (
                  <div className="celda-totales" style={{ fontSize: "12px" }}>
                    <div>{dineroDisabledMask(subtotal)}</div>
                    <div>{dineroDisabledMask(impuestos)}</div>
                    <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                  </div>
                );
              }}
            </FormItem>
            <FormItem {...restField} name={[name, "subtotal"]}  fieldKey={[arrayKey, "subtotal"]}  hidden><InputNumberItem /></FormItem>
            <FormItem {...restField} name={[name, "impuestos"]} fieldKey={[arrayKey, "impuestos"]} hidden><InputNumberItem /></FormItem>
            <FormItem {...restField} name={[name, "total"]}     fieldKey={[arrayKey, "total"]}     hidden><InputNumberItem /></FormItem>
          </td>
        </tr>

        {/* Fila de detalles del insumo */}
        {this.state.mostrarDetalles && (
          <FormItem
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              const prev = prevValues.insumos?.[arrayKey];
              const curr = currentValues.insumos?.[arrayKey];
              return (
                prev?.cantidad !== curr?.cantidad ||
                prev?.insumoId !== curr?.insumoId ||
                prev?.precioUnitario !== curr?.precioUnitario
              );
            }}
          >
            {({ getFieldValue }) => {
              const insumos    = getFieldValue("insumos");
              const insumoData = insumos?.[arrayKey];
              const cantidad   = insumoData?.cantidad;
              const insumoId   = insumoData?.insumoId;
              const costo      = insumoData?.precioUnitario;

              let insumo = null;
              if (insumoId && this.state.todasInsumos) {
                insumo = this.state.todasInsumos.find((v) => v._id === insumoId);
              }
              if (!insumo) return null;
              return (
                <InsumoDetalleRow
                  insumo={insumo}
                  cantidad={cantidad}
                  costo={costo}
                  colSpans={{ details: 3, projection: 2, filler: 3 }}
                  disabledModal={true}
                />
              );
            }}
          </FormItem>
        )}
      </React.Fragment>
    );
  }

  getObservacionesConfig() {
  return {
    totales: (
      <div style={{ marginTop: 8 }}>
        <table className="table totales-table" style={{ borderCollapse: "collapse", width: "100%", margin: 0, tableLayout: "auto" }}>
              <tbody>
                <tr style={{ marginBottom: 10 }}>
                  <th
                    className="td-totales-center"
                    style={{ width: "25%" }}
                  ></th>
                  <td className="td-totales-center" style={{ width: "25%"}}>
                      <Tag style={{ backgroundColor: "#f5f5f5",borderColor: "#d9d9d9", color: "#595959",fontWeight: 600, padding: "2px 30px",borderRadius: "6px"
                      }}
                    >
                      Ajuste
                    </Tag>
                  </td>
                  <td
                    className="td-totales-center"
                    style={{ width: "25%" }}
                  ></td>
                </tr>
                <tr>
                  <th className="th-totales" style={{ width: "25%" }}>
                    Subtotal
                  </th>
                  <td
                    className="td-totales-right"
                    style={{ width: "25%" }}
                  >
                    <InputNumberItem
                      sinBorde
                      dineroDisabled
                      disabled
                      value={this.state.ajusteSubtotal}
                    />
                  </td>
                  <td
                    className="td-totales-right"
                    style={{ width: "25%" }}
                  >
                    {dineroDisabledMask(this.state.subtotal)}
                  </td>
                </tr>
              </tbody>
              {this.state.arrayImpuestos.map((valueArray) => (
                <tbody>
                  <tr key={valueArray.descripcionFactura}>
                    <th className="th-totales" style={{ width: "25%" }}>
                      {valueArray.descripcionFactura}
                    </th>
                    <td
                      className="td-totales-right"
                      style={{ width: "25%" }}
                    >
                      <InputNumberItem
                        sinBorde
                        dineroDisabled
                        disabled
                        value={valueArray.ajusteImpuesto}
                      />
                    </td>
                    <td className="td-totales-right">
                      {dineroDisabledMask(valueArray.totalImpuestos)}
                    </td>
                  </tr>
                </tbody>
              ))}
              <tbody>
                <tr>
                  <th className="th-totales" style={{ width: "25%" }}>Total</th>
                  <td
                    className="td-totales-right"
                    style={{ width: "25%" }}
                  ></td>
                  <td className="td-totales-right">
                    {dineroDisabledMask(this.state.total)}
                  </td>
                </tr>
              </tbody>
              {this.state.arrayRetenciones.map((value) => (
                <tbody>
                  <tr>
                    <th className="th-totales" style={{ width: "25%" }}>
                      {value.descripcionFactura}
                    </th>
                    <td
                      className="td-totales-right"
                      style={{ width: "25%" }}
                    >
                      <InputNumberItem
                        sinBorde
                        dineroDisabled
                        disabled
                        value={value.ajusteRetencion}
                      />
                    </td>
                    <td className="td-totales-right">
                      {dineroDisabledMask(value.totalRetenciones)}
                    </td>
                  </tr>
                </tbody>
              ))}
              <tbody>
                <tr>
                  <th className="th-totales" style={{ width: "25%" }}>Total a pagar</th>
                  <td
                    className="td-totales-right"
                    style={{ width: "25%" }}
                  ></td>
                  <td className="td-totales-right">
                    {dineroDisabledMask(this.state.totalPagar)}
                  </td>
                </tr>
              </tbody>
         </table>
      </div>
    ),
  };
}

  renderProyectoCard() {
  return (
    <FormItem shouldUpdate noStyle>
      {({ getFieldValue }) => {
        const proyectoId = getFieldValue("proyectoId");
        const proveedorId = getFieldValue("proveedorId");

        const proyecto = proyectoId
          ? this.state.todasProyectos?.find((v) => v._id === proyectoId)
          : null;

        const proveedor = proveedorId
          ? this.state.todasProveedores?.find((v) => v._id === proveedorId)
          : null;

        if (!proyecto && !proveedor) return null;

        const proveedorSections = proveedor
          ? [
              {
                title: "Datos generales",
                icon: <InfoCircleOutlined />,
                iconColor: "#00BFD6",
                lg: 14,
                items: [
                  {
                    label: "Nombre",
                    value: proveedor.nombre
                      ? `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
                      : proveedor.razonSocial || "-",
                    bold: true, 
                  },
                  { label: "RFC",      value: proveedor.rfc      || "-" },
                  { label: "Correo",   value: proveedor.correo   || "-" },
                  { label: "Teléfono", value: proveedor.telefono || "-" },
                  { label: "Celular",  value: proveedor.celular  || "-" },
                ],
              },
              {
                title: "Contacto",
                icon: <PhoneFilled />,
                iconColor: "#DB2777",
                lg: 10,
                items: [
                  { label: "Contacto",          value: proveedor.nombreContacto   || "-" },
                  { label: "Teléfono",        value: proveedor.telefonoContacto || "-" },
                  { label: "Correo",          value: proveedor.correoContacto   || "-" },
                  { label: "Días de crédito", value: proveedor.diasCredito       ?? "-" },
                ],
              },
            ]
          : [];

        if (!proyecto) {
          return (
            <Row>
              <InfoCard
                title="PROVEEDOR"
                accentColor="#00BFD6"
                compact
                sections={proveedorSections}
              />
            </Row>
          );
        }

        return (
          <Row>
            <InfoCard
              title="PROYECTO"
              accentColor="#00BFD6"
              icon={<InfoCircleOutlined />}           
              compact
              sections={[
                {
                  title: "Información General",
                  icon: <InfoCircleOutlined />,
                  iconColor: "#00BFD6",
                  lg: 8,
                  items: [
                    { label: "Nombre",      value: proyecto.nombre      || "-" },
                    { label: "Descripción", value: proyecto.descripcion || "-" },
                  ],
                },
                {
                  title: proyecto.calle ? "Dirección" : "Vehículo",
                  icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                  iconColor: "#C9DF00",
                  lg: 8,
                  items: proyecto.calle
                    ? [{ label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` }]
                    : [
                        { label: "Marca",  value: proyecto.marca  || "-" },
                        { label: "Modelo", value: proyecto.modelo || "-" },
                        { label: "Placas", value: proyecto.placas || "-" },
                      ],
                },
                {
                  title: "Detalles",
                  icon: <CarOutlined />,
                  iconColor: "#FF6A0D",
                  lg: 8,
                  items: [
                    { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                    { label: "ID",   value: proyecto._id ? proyecto._id.slice(-6).toUpperCase() : "-" },
                  ],
                },
              ]}
              splitWith={
                proveedor
                  ? {
                      title: "PROVEEDOR",
                      accentColor:"#00BFD6",
                      icon:<UserOutlined />,
                      compact: true,
                      sections: proveedorSections,
                    }
                  : undefined
              }
            />
          </Row>
        );
      }}
    </FormItem>
  );
}

  render() {
    const isMobile = window.innerWidth < 768;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Remisión"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="verRemision"
              layout
            >
            <div style={{ padding: '0 16px', marginBottom: 16 }}>
              {this.renderProyectoCard()}
            </div>
            <GeneralFormLayout
                cards={[
                  /*{
                    title: "Datos Generales",
                    lg: 18,
                    content: (
                      <Row>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <FormItem
                            label="Proyecto"
                            name="proyectoId"
                            margin
                            required
                            disabled
                          >
                            <SelectItem placeholder="Proyecto" disabled>
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                          <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              let proyectoId = getFieldValue("proyectoId");
                              if (!proyectoId) return null;
                              const proyecto = this.state.todasProyectos?.find(
                                (value) => value?._id?.toString() === proyectoId?.toString()
                              );
                              if (!proyecto) return null;
                              if (
                                !proyecto.subProyectos || 
                                proyecto.subProyectos?.length === 0
                              )
                                return null;

                              const opciones = proyecto?.subProyectos?.map((value) => (
                                <Option value={value?._id} key={value?._id}>
                                  {value?.codigo + " - " + value?.nombre}
                                </Option>
                              ));

                              return (
                                <FormItem label="Subproyecto" name="subProyectoId" margin>
                                  <SelectItem placeholder="Subproyecto" allowClear disabled>
                                    {opciones}
                                  </SelectItem>
                                </FormItem>
                              );
                            }}
                          </FormItem>
                        </Col>
                       
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <FormItem label="Proveedor" name="proveedorId" margin required
                           labelCol
                          >
                            <SelectItem placeholder="Proveedor" disabled>
                              {this.state.objetoProveedores}
                            </SelectItem>
                          </FormItem>
                        </Col>
                      
                      </Row>
                    ),
                  },*/
                  
                  {
                    title: "Datos Remisión",
                    lg: 18,
                    content: (
                      <Row>
                        <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                          <FormItem
                            name="numeroRemision"
                            label="Número Factura"
                            margin
                            pattern
                            tooltip="Numeración interna de la factura."
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 13 }}
                          >
                            <InputItem placeholder="Número Factura" disabled />
                          </FormItem>
                          <FormItem name="codigoRemision" label="Codigo Remisión" margin pattern
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 13 }}
                          >
                            <InputItem placeholder="Codigo Remisión" disabled />
                          </FormItem>
                          <FormItem name="descripcion" label="Descripcion" margin pattern
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 13 }}>
                            <InputItem placeholder="Descripcion" disabled />
                          </FormItem>
                        </Col>
                        <Col span={12} xs={24} sm={24} lg={11} xl={11}>
                          <FormItem label="Fecha de Remisión" name="fechaRemision" required margin
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 10 }}
                          >
                            <DatePickerItem
                              placeholder="Fecha de Remisión"
                              allowClear={false}
                              disabled
                            />
                          </FormItem>
                          <FormItem label="Días de credito" name="diasCredito" required number margin
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 6 }}
                          >
                            <InputNumberItem placeholder="Días de Credito" disabled />
                          </FormItem>
                          <FormItem label="Fecha probable Pago" name="fechaPago" required margin
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 10 }}
                          >
                            <DatePickerItem
                              placeholder="Fecha probable Pago"
                              allowClear={false}
                              disabled
                            />
                          </FormItem>
                          <FormItem label="Fecha Vencimiento" name="fechaVencimiento" required margin
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 10 }}
                          >
                            <DatePickerItem
                              placeholder="Fecha Vencimiento"
                              allowClear={false}
                              disabled
                            />
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 6,
                    content: (
                      <>
                        <FormItem
                          required
                          margin
                          name="monedaId"
                          label="Moneda"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue="60c7e4396465ad440c41c15a"
                        >
                          <SelectItem
                            disabled
                            onChange={(value) => {
                              if (value === "60c7e4396465ad440c41c15a") {
                                this.formRef.current.setFieldsValue({ tipoDeCambio: 1 });
                              }
                            }}
                            placeholder="Moneda"
                          >
                            {this.state.objetoMonedas}
                          </SelectItem>
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                          {({ getFieldValue, setFieldsValue }) => {
                            const monedaId = getFieldValue('monedaId');
                            const esMxn = monedaId === '60c7e4396465ad440c41c15a';
                            if (esMxn && getFieldValue('tipoDeCambio') !== 1) {
                              setTimeout(() => setFieldsValue({ tipoDeCambio: 1 }), 0);
                            }
                            return esMxn ? (
                              <FormItem
                                name="tipoDeCambio"
                                hidden
                                initialValue={1}
                              >
                                <InputNumberItem />
                              </FormItem>
                            ) : (
                              <FormItem
                                required
                                number
                                margin
                                label="T. Cambio"
                                name="tipoDeCambio"
                                type="number"
                                initialValue={1}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem disabled dinero placeholder="T. Cambio" />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow.bind(this),
                      renderHeader: () => (
                        <Row justify="end" style={{ marginBottom: "0px" , marginRight: "15px" }}>
                          <Col>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888"  }}>
                                Mostrar detalles: 
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.mostrarDetalles}
                                onChange={(checked) =>
                                  this.setState({ mostrarDetalles: checked })
                                }
                              />
                            </Space>
                          </Col>
                        </Row>
                      ),
                    },
                  ],
                }}
                observacionesConfig={this.getObservacionesConfig()}
                isMobile={isMobile}
                actionButtons={(
                  <>
                    {this.state.totalPagado > 0 && (
                      <ButtonItem
                        type="primary"
                        icon={<DollarOutlined />}
                        verdeB
                        onClick={() => this.setState({ modalPagos: true })}
                        hotkey="shift+p"

                      >
                        Pagos
                      </ButtonItem>
                    )}
                    <ButtonItem
                      type="primary"
                      onClick={this.abrirModalCorreo.bind(this)}
                      moradoB
                      hotkey="shift+m"
                    >
                      Mandar Correo
                    </ButtonItem>
                    <ButtonItem
                      type="primary"
                      rojoB
                      onClick={this.atras.bind(this)}
                      hotkey="shift+r"
                    >
                      Regresar
                    </ButtonItem>
                  </>
                )}
              />
            </Form>
          </Spin>
        </div>
        <PagosRemision
          visible={this.state.modalPagos}
          id={this.state.id}
          cerrarPagosRemision={this.cerrarPagosRemision.bind(this)}
        />
        <ModalMandarCorreoFacturas
          visible={this.state.modalCorreo}
          id={this.state.id}
          cerrarModalMandarCorreoFacturas={this.cerrarModalCorreo.bind(this)}
          tipoFactura={"Remisión"}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VerRemision);